import { DossierDetailsContent, DossierDetailsHeader, DossierDetailsPanel } from "@/app/pages/dossier/dossier-details-panel";
import { useGetDossierBetrokkenTreinenById } from "@/entities/betrokken-treinen";
import { RoleGate, UserRole } from "@/features/auth";
import { BetrokkenTreinItem } from "@/features/betrokken-treinen/components/betrokken-trein-item.tsx";
import { useDossierId } from "@/features/dossier-details";
import { Button, Empty, EmptyHeader, EmptyImage, EmptyTitle, ErrorDisplay, Skeleton } from "@/shared/components";
import { useSearchParams } from "react-router";
import { AddBetrokkenTreinDialog } from "./add-betrokken-trein/add-betrokken-trein-dialog";

export function BetrokkenTreinenDetails() {
    const id = useDossierId();
    const [searchParams] = useSearchParams();
    const preselectedTreinId = searchParams.get("treinId");
    const {
        data: betrokkenTreinen,
        isPending,
        error,
    } = useGetDossierBetrokkenTreinenById(id, (betrokkenTreinen) => betrokkenTreinen.filter((trein) => trein.isRelevant));

    if (error)
        return (
            <DossierDetailsPanel>
                <DossierDetailsHeader section="BetrokkenTreinen" showBackButton />
                <DossierDetailsContent>
                    <ErrorDisplay error={error} title="Fout bij het laden van betrokken treinen" />
                </DossierDetailsContent>
            </DossierDetailsPanel>
        );

    if (isPending) {
        return (
            <DossierDetailsPanel>
                <DossierDetailsHeader section="BetrokkenTreinen" showBackButton />
                <DossierDetailsContent>
                    <Skeleton className="h-4 w-full" />
                </DossierDetailsContent>
            </DossierDetailsPanel>
        );
    }

    if (!betrokkenTreinen.length) {
        return (
            <DossierDetailsPanel>
                <DossierDetailsHeader section="BetrokkenTreinen" showBackButton />
                <DossierDetailsContent className="flex flex-col gap-4">
                    <Empty>
                        <EmptyHeader className="flex justify-center font-normal">
                            <EmptyImage />
                            <EmptyTitle className="text-s text-content-subtle">Geen betrokken treinen toegevoegd</EmptyTitle>
                        </EmptyHeader>
                    </Empty>
                    <RoleGate roles={[UserRole.REGIEVOERDER]}>
                        <div className="flex justify-center">
                            <AddBetrokkenTreinDialog dossierNummer={id}>
                                <Button icon="train" variant="secondary">
                                    Trein toevoegen
                                </Button>
                            </AddBetrokkenTreinDialog>
                        </div>
                    </RoleGate>
                </DossierDetailsContent>
            </DossierDetailsPanel>
        );
    }

    return (
        <DossierDetailsPanel>
            <DossierDetailsHeader showBerichtBalk showBackButton section="BetrokkenTreinen">
                <RoleGate roles={[UserRole.REGIEVOERDER]}>
                    <AddBetrokkenTreinDialog dossierNummer={id}>
                        <Button size="s" iconSize="xs" icon="train" variant="secondary">
                            Trein toevoegen
                        </Button>
                    </AddBetrokkenTreinDialog>
                </RoleGate>
            </DossierDetailsHeader>
            <DossierDetailsContent>
                <ol>
                    {betrokkenTreinen.map((trein) => (
                        <BetrokkenTreinItem
                            key={trein.id}
                            dossierId={id}
                            trein={trein}
                            defaultOpen={!preselectedTreinId || preselectedTreinId === String(trein.id)}
                        />
                    ))}
                </ol>
            </DossierDetailsContent>
        </DossierDetailsPanel>
    );
}
